<h1>
  New Application
</h1>
<form #form="ngForm" (ngSubmit)="submitForm(form)" autocomplete="off" novalidate>
  <!-- Page1 -->
  <ng-container *ngIf="!creationModel.projectsIsLoaded">
    <div class="create-dc--subtitle">
      <div>
        Each new app must be connected to a project in your tenant in the FlexiCapture Cloud (<a href="{{ urlCloud }}">{{ urlCloud }}</a>)
      </div>
      <div class="create-dc--mt10">Please enter the following information to setup the connection.</div>
    </div>
    <ui-input>
      <input uiInput
        tabindex="1"
        type="text"
        name="tenant"
        #tenant="ngModel"
        [(ngModel)]="creationModel.tenant"
        placeholder="Your FlexiCapture Tenant"
        required
        autocomplete="off"
        [disabled]="creationModel.projectsIsLoaded"
        (ngModelChange)="onHideError()"/>
      <ui-input-error [input]="tenant" name="required">
        Your FlexiCapture Tenant is required
      </ui-input-error>
    </ui-input>
    <ui-input>
      <input uiInput
        tabindex="2"
        type="text"
        name="login"
        #login="ngModel"
        [(ngModel)]="creationModel.login"
        placeholder="Username for an account in the Tenant"
        required
        autocomplete="off"
        [disabled]="creationModel.projectsIsLoaded"
        (ngModelChange)="onHideError()"/>
      <ui-input-error [input]="login" name="required">
        Username for an account in the Tenant is required
      </ui-input-error>
    </ui-input>
    <ui-input>
      <input uiInput
        tabindex="3"
        type="password"
        name="password"
        [(ngModel)]="creationModel.password"
        #password="ngModel"
        (ngModelChange)="onHideError()"
        placeholder="Password for the account in the Tenant"
        autocomplete="new-password"
        [disabled]="creationModel.projectsIsLoaded"
        required />
      <ui-input-error [input]="password" name="required">
        Password for the account in the Tenant is required
      </ui-input-error>
      <ui-input-error [input]="password" name="passwordValid">
        Please enter a valid password
      </ui-input-error>
    </ui-input>
    <p class="create-dc--text-trial">
      Don't have a tenant yet? <a href="mailto:sales@abbyy.com?subject=New%20trial%20tenant%20request%20on%20{{ urlCloud }}">
      Request a trial</a>.
    </p>
  </ng-container>
  <!-- Page2 -->
  <ng-container *ngIf="creationModel.projectsIsLoaded">
      <ui-input class="create-dc--input-disp-none">
      <input
        uiInput
        type="text"
        name="selectedProject"
        #name="ngModel"
        [(ngModel)]="creationModel.selectedProject"
        required
        autocomplete="off"
        (ngModelChange)="onHideError()"
        hidden/>
      <ui-input-error [input]="name" name="required">Project is required</ui-input-error>
    </ui-input>
    <ui-selectbox
      tabindex="6"
      [name]="creationModel.selectedProject"
      [(ngModel)]="creationModel.selectedProject"
      placeholder="Choose the project"
      (ngModelChange)="changeProject($event)"
      name="project"
      [ngModelOptions]="{ standalone: true }">
      <ui-option *ngFor="let value of creationModel.projects" [value]="value">
        {{ value }}
      </ui-option>
    </ui-selectbox>
    <ui-input>
      <input
        uiInput
        tabindex="7"
        type="text"
        name="name"
        #name="ngModel"
        [(ngModel)]="creationModel.name"
        placeholder="Application name"
        required
        autocomplete="off"
        maxlength="40"
        (ngModelChange)="changeName($event)" />
      <ui-input-error [input]="name" name="required">Application name is required</ui-input-error>
    </ui-input>
    <p class="create-dc--text-trial">
      ID and Token will be assigned after creating the application
    </p>
    <p class="create-dc--text-trial create-dc--text-permissions">
      Not seeing your project? Check permissions in the<br />
      <a href="{{ urlCloud }}/FlexiCapture12/Monitoring/{{ creationModel.tenant }}#Settings/Users"
          target="_blank" >
        Administration &amp; Monitoring Console </a><br />
      and click «Refresh»
    </p>
  </ng-container>
  <!-- FOOTER -->
  <p class="ui-input-error create-dc--text-error"
    *ngIf="error"
    [ngSwitch]="error"
    [class.visible]="error">
    <span *ngSwitchDefault><span [innerHTML]="errorDescription"></span></span>
  </p>
  <div class="create-dc--container-btns">
    <div>
        <a *ngIf="creationModel.projectsIsLoaded"
          class="create-dc--btn-trial"
          (click)="getProjects()">
          Refresh
        </a>
    </div>
    <div class="buttons">
      <button type="submit"
        tabindex="8"
        class="default"
        (click)="validate(form)"
        [disabled]="form.invalid">
        {{ !creationModel.projectsIsLoaded ? 'Next' : 'Create' }}
      </button>
      <button class="outline" type="button" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
  <ui-loading *ngIf="isLoading"></ui-loading>
</form>
